import { createI18n } from 'vue-i18n'
import de from './de.json'
import en from './en.json'

// Erweiterte Hotel-Edition-Strings (PreOrder, Allergie, Browser-Detect-UI)
import deHotel from './hotel.de.json'
import enHotel from './hotel.en.json'
import itHotel from './hotel.it.json'

const SUPPORTED = ['de', 'en', 'it']

/**
 * Bestimmt die Anzeigesprache nach Priorität:
 *  1. localStorage `userLanguage` (manuelle Auswahl)
 *  2. URL-Query `?lang=…`
 *  3. Browser-Sprache (navigator.languages → navigator.language)
 *  4. 'de' als Fallback
 */
function detectLocale() {
  if (typeof window === 'undefined') return 'de'
  const saved = localStorage.getItem('userLanguage')
  if (saved && SUPPORTED.includes(saved)) return saved

  const params = new URLSearchParams(window.location.search)
  const fromUrl = params.get('lang')
  if (fromUrl && SUPPORTED.includes(fromUrl)) return fromUrl

  const candidates = navigator.languages?.length ? navigator.languages : [navigator.language || 'de']
  for (const cand of candidates) {
    const short = (cand || '').split('-')[0].toLowerCase()
    if (SUPPORTED.includes(short)) return short
  }
  return 'de'
}

function deepMerge(target, source) {
  for (const key of Object.keys(source || {})) {
    if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
      target[key] = deepMerge(target[key] ?? {}, source[key])
    } else {
      target[key] = source[key]
    }
  }
  return target
}

const i18n = createI18n({
  legacy: false,
  locale: detectLocale(),
  fallbackLocale: 'en',
  messages: {
    de: deepMerge({ ...de }, deHotel),
    en: deepMerge({ ...en }, enHotel),
    it: itHotel,
  },
})

export default i18n
export { SUPPORTED as supportedLocales, detectLocale }
